import cx from 'classnames'
import { QRCodeSVG } from 'qrcode.react'

import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

interface ReferFriendLinkProps {
  shareUrl: string
}

export default function ReferFriendsQRCode({ shareUrl }: ReferFriendLinkProps) {
  const { isDarkMode } = useThemeContext()

  return (
    <div
      data-test='invite-friends-qr-code'
      className={cx(classes.qrCodeContainer, isDarkMode && classes.qrCodeContainerDarkMode)}
    >
      <div className={classes.qrCodeWrapper}>
        <QRCodeSVG value={shareUrl} className={classes.qrCode} />
      </div>
    </div>
  )
}
